export default {"src":"/_next/static/media/integer-chips.a794fbc0.svg","height":120,"width":131,"blurWidth":0,"blurHeight":0};